import React from "react"

import styled from "styled-components"
import {
  BGWrapper,
  H2,
  H3,
  StrongT,
  ButtonsWrapper,
  HeadingWrapper
} from "./UIStyle/UIstyle"
import { theme } from "./mixin"
import Button from "./Button"
import SliderSection from "./SliderSection"
import Countdown from "react-countdown"

import PositionAndWidth from "./PositionAndWidth"
import Decoration from "./Decoration"
import pic1 from "@/common/assets/image/lucky-bag-2023/partner/beastR.webp"
import pic2 from "@/common/assets/image/lucky-bag-2023/partner/domhieR.webp"
import pic3 from "@/common/assets/image/lucky-bag-2023/partner/NornsR.webp"
import pic4 from "@/common/assets/image/lucky-bag-2023/partner/KuaicherR.webp"
import pic5 from "@/common/assets/image/lucky-bag-2023/partner/okR.webp"
const rewards_data = [
  { img: pic1, title: "野獸國行動商城", discount: "1000" },
  { img: pic2, title: "東海模型", discount: "200" },
  { img: pic3, title: "Norns", discount: "100" },
  { img: pic4, title: "快車肉乾", discount: "100" },
  { img: pic5, title: "歐可茶葉", discount: "50" }
]

export default function Rewards({ dayS, dayE }) {
  const rendererButton = ({ total, days, hours, minutes, seconds }) => {
    return (
      <>
        {!total ? (
          <Button
            className="hover"
            content="活動結束，感謝參與"
            id="toybox-HeroButton"
            secondary
            disable
          />
        ) : (
          <Button content="立刻領取" href="#top" id="toybox-rewardsButton1" />
        )}
      </>
    )
  }
  return (
    <Wrapper id="REWARDS" bg={theme.bgLinearBottom}>
      <ContentWrapper>
        <BGWrapper>
          <PositionAndWidth
            d={{ width: "80%", t: "0%", r: "10%" }}
            m={{ width: "100%", t: "2%", r: "0%" }}
          >
            <Decoration type="starBG" time={12} delay={0} />
          </PositionAndWidth>

          <PositionAndWidth
            d={{ width: "4%", t: "15%", r: "-2%" }}
            m={{ width: "8%", t: "40%", l: "-4%" }}
          >
            <Decoration type="circle" animation="updown" time={12} delay={3} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "10%", b: "5%", r: "-2%" }}
            m={{ width: "8%", t: "40%", l: "-4%" }}
          >
            <Decoration
              type="blobman1"
              animation="updown"
              time={12}
              delay={3}
            />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "1%", t: "50%", r: "-0.5%" }}
            m={{ width: "3%", t: "50%", r: "-1.5%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={9} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "1.5%", b: "-0.75%", l: "40%" }}
            m={{ width: "3%", b: "-0%", l: "40%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={2} />
          </PositionAndWidth>
        </BGWrapper>
        <HeadingWrapper>
          <H3 color={theme.CTAcolor}>REWARDS</H3>
          <H2>好禮送不停</H2>
          <StrongT>中獎率 100% ，每個玩具盒NFT 都有獎勵！</StrongT>
        </HeadingWrapper>
        <SliderWrapper>
          <SliderSection data={rewards_data} />
        </SliderWrapper>
        <ButtonsWrapper>
          <Countdown date={dayS} renderer={rendererButton} />
          <Button
            content="更多資訊"
            secondary
            arrow
            href="#PARTNERS"
            id="toybox-rewardsButton1"
          />
        </ButtonsWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  position: relative;

  overflow: hidden;
  padding: 20px 60px 20px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg};
  @media (${theme.md}) {
    padding: 20px 20px 20px 20px;
  }
`
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  border-radius: 73px;
  width: 100%;
  max-width: 1000px;
  gap: 32px;
  padding: 60px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (${theme.xl}) {
    border-radius: 36px;
  }
  @media (${theme.lg}) {
    border-radius: 36px;
    padding: 60px 20px 60px 20px;
  }

  @media (${theme.md}) {
    padding: 60px 20px 60px 20px;
    gap: 36px;
  }
`

const SliderWrapper = styled.div`
  width: 100vw;
`
